/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Strength_Level_OlympicInputs */

const en_strength_level_olympic = /** @type {(inputs: Strength_Level_OlympicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Olympic`)
};

const pl_strength_level_olympic = /** @type {(inputs: Strength_Level_OlympicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Olimp`)
};

/**
* | output |
* | --- |
* | "Olympic" |
*
* @param {Strength_Level_OlympicInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const strength_level_olympic = /** @type {((inputs?: Strength_Level_OlympicInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Strength_Level_OlympicInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_strength_level_olympic(inputs)
	return en_strength_level_olympic(inputs)
});